import {createAction} from '@reduxjs/toolkit'
import {POLICY_TYPE, RESOURCE_TYPE} from 'interfaces'

// top 10 blocks actions
export const setViolationTypeFilter = createAction<POLICY_TYPE[]>(
  'setViolationTypeFilter',
)
export const addEntityTypeFilter = createAction<RESOURCE_TYPE>(
  'addEntityTypeFilter',
)
export const removeEntityTypeFilter = createAction<RESOURCE_TYPE>(
  'removeEntityTypeFilter',
)
export const resetTopTenBlocksFilterState = createAction(
  'resetTopTenBlocksFilterState',
)
